import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    payload: [
      {
        "classification": {"score":"None"},
        "displayName": "None"
      }
    ],
    token: "ya29.c.Kl6bB1qyaGjiOjCITGWIQ1TGhIahcMGMbSzEhNC4nOne-RKSRYDUI2HVcpVSR7QD2zzbxgwgCkSdmj3I9H4Sqygxq1hPkzrfSODuPOvmoUiEZBU_7hHmlICNO-STGfxO"
  },
  mutations: {},
  actions: {}
});
